import {
  BackArrowIcon,
  // CallIcon,
  ComplaintIcon,
  FaceRecIcon,
  ProcedureIcon
  // TrackIcon
} from "../../Assets/assets";
import Header from "../../Components/Header/Header";
import { rippleEffect } from "../../Utils/constants";
import "./Home.css";

export default function Home(props) {
  const data = [
    ...(props.claims?.complaints?.read?.connected ||
    props.claims?.complaints?.read?.all
      ? [
          {
            title: "COMPLAINTS",
            description: "Manage assigned complaints",
            image: <ComplaintIcon />,
            goTo: "/complaints"
          }
        ]
      : []),
    ...(props.claims?.procedures?.read
      ? [
          {
            title: "PROCEDURES",
            description: "Manage assigned procedures",
            image: <ProcedureIcon />,
            goTo: "/locationSearch"
          }
        ]
      : []),
    // {
    //   title: "CALLS",
    //   description: "Manage customer support calls",
    //   image: <CallIcon />,
    //   goTo: "/complaints"
    // },
    // {
    //   title: "TRACKING",
    //   description: "Track work by Start & Stop",
    //   image: <TrackIcon />,
    //   goTo: "/complaints"
    // },
    ...(props.claims?.surveillance?.read && props.claims?.surveillance?.update
      ? [
          {
            title: "FACE CAPTURE",
            description: "Capture attendance at specified intervals",
            image: <FaceRecIcon />,
            goTo: "/faceIdentification/lastCapturedAttendance"
          }
        ]
      : [])
  ];

  return (
    <div className="inherit-parent-height inherit-parent-width">
      <Header
        theme={props.auth.theme.primaryColor === "#0E0E0E" ? "dark" : "light"}
        title="GCC"
        profileOnClick={() => {
          props.navigate("/settings");
        }}
      />

      <div className="remaining-body-height flex-direction-column">
        <div
          style={{
            fontStyle: "bold"
          }}
          className="text-align-center padding-top-larger"
        >
          EMPLOYEE PORTAL
        </div>
        <div>
          {props.claims?.moduleAccess &&
            data.map((data, index) => (
              <div className="inherit-parent-width" key={index}>
                <CategoryCards
                  data={data}
                  index={index + 1}
                  comingSoon={["TRACKING"].includes(data.title) ? true : false}
                  onClick={(event) => {
                    rippleEffect(event);
                    if (!["TRACKING"].includes(data.title)) {
                      props.navigate(data.goTo);
                    }
                  }}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

const CategoryCards = (props) => {
  return (
    <>
      <div
        onClick={(e) => {
          props.onClick(e);
        }}
        data-cy={`${props.data.title}-CARD`}
        className="display-flex height-fit-content position-relative"
      >
        {props.comingSoon && (
          <div className="overlay font-size-medium font-color-tertiaryColor6">
            COMING SOON...
          </div>
        )}

        <div
          style={{
            padding: "15px"
          }}
          className={`inherit-parent-width height-fit-content`}
        >
          <div className="flex-justify-content-center flex-direction-column">
            <div>{props.data.image}</div>
            <div className="font-size-medium font-color-tertiaryColor6">
              {props.data.title}
            </div>

            <div className="inherit-parent-width display-flex flex-justify-content-space-between">
              <div className="font-size-small padding-top-default font-color-tertiaryColor5">
                {props.data.description}
              </div>
              <div
                style={{
                  transform: "rotate(180deg)"
                }}
              >
                <BackArrowIcon color="var(--tertiaryColor6)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
